import { createContext } from 'react';
import { mediaAccessResult } from '../models';

const MediaAccessContext = createContext<mediaAccessResult | undefined>({} as mediaAccessResult);
export default MediaAccessContext;
